export enum HotelRoomingListGuestStatus {
  Saved = 'SAVED',
  Changed = 'CHANGED',
  LimitDatePassed = 'LIMIT_DATE_PASSED',
}
